module.exports = __webpack_public_path__ + "assets/tv2.37925d7f.svg";